var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-unavailable-container"},[_c('div',{staticClass:"square-box"},[_c('div',{staticClass:"square-box__content"},[_c('v-icon',{staticClass:"preview-unavailable-icon"},[_vm._v(" mdi-eye-off ")]),_c('h1',{staticClass:"preview-unavailable-text"},[_vm._v(" "+_vm._s(_vm.$t('HOME.NO_PREVIEW_AVAILABLE'))+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }